import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AdminLoginModal.css";
import logo from "../assets/logo_sgoolfotografie.svg";

const AdminLoginModal = ({ isOpen, onClose }) => {
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAdminSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!adminEmail || !adminPassword) {
      setErrorMessage("E-mail en wachtwoord zijn verplicht.");
      return;
    }

    try {
      setLoading(true);
      setErrorMessage("");

      // Call backend API
      const response = await axios.post("https://sgoolfoto-backend.onrender.com/api/admin/login", {
        email: adminEmail,
        password: adminPassword,
      });

      if (response.data.success) {
        // Store admin user data in localStorage
        localStorage.setItem("admin_user", JSON.stringify(response.data.user));
        
        // Close modal and navigate to admin dashboard
        onClose();
        navigate("/admin-dashboard");
      } else {
        setErrorMessage(response.data.error || "Aanmelden mislukt");
      }
    } catch (error) {
      console.error("Admin login error:", error);
      
      if (error.response?.status === 401) {
        setErrorMessage("Ongeldig e-mailadres of wachtwoord");
      } else if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage("Er is een fout opgetreden tijdens het aanmelden. Probeer het opnieuw.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAdminEmail("");
    setAdminPassword("");
    setErrorMessage("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose}>
          ✕
        </button>
        <div className="modal-header">
          <img src={logo} alt="App Logo" className="modal-logo-img" />
          <h2>Beheerder Aanmelden</h2>
          <p>Voer uw beheerdersgegevens in om toegang te krijgen tot alle rapporten</p>
        </div>

        <form onSubmit={handleAdminSubmit} className="admin-form">
          <div className="form-group">
            <label htmlFor="modal-admin-email">
              Beheerder E-mail <span className="required">*</span>
            </label>
            <input
              type="email"
              id="modal-admin-email"
              value={adminEmail}
              onChange={(e) => {
                setAdminEmail(e.target.value);
                setErrorMessage("");
              }}
              placeholder="Voer e-mailadres in"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="modal-admin-password">
              Wachtwoord <span className="required">*</span>
            </label>
            <input
              type="password"
              id="modal-admin-password"
              value={adminPassword}
              onChange={(e) => {
                setAdminPassword(e.target.value);
                setErrorMessage("");
              }}
              placeholder="Voer wachtwoord in"
              required
            />
          </div>

          {errorMessage && <p className="error-text">{errorMessage}</p>}

          <button type="submit" className="btn" disabled={loading}>
            {loading ? "Aanmelden..." : "Aanmelden als Beheerder"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginModal;

